import { useState, useMemo, useCallback } from 'react'
import { GALLERY_STEP } from '~/constants/product'

export default function useGalleryDialog() {
  const [gallerySelectFile, setGallerySelectFile] = useState(0)
  const [galleryStep, setGalleryStep] = useState(GALLERY_STEP.SELECT)
  const [openGallery, setOpenGallery] = useState(false)

  const handleOpenGallery = useCallback(() => {
    setOpenGallery(true)
    setGalleryStep(GALLERY_STEP.SELECT)
  }, [setOpenGallery, setGalleryStep])

  const handleOpenFileSelect = useCallback(
    (fileIdx) => {
      setGalleryStep(GALLERY_STEP.PREVIEW)
      setOpenGallery(true)
      setGallerySelectFile(fileIdx)
    },
    [setGalleryStep, setOpenGallery, setGallerySelectFile],
  )

  const onClose = useCallback(() => {
    setOpenGallery(false)
  }, [])

  const galleryProps = useMemo(
    () => ({
      gallerySelectFile,
      setGallerySelectFile,
      galleryStep,
      setGalleryStep,
      openGallery,
      setOpenGallery,
    }),
    [
      gallerySelectFile,
      setGallerySelectFile,
      galleryStep,
      setGalleryStep,
      openGallery,
      setOpenGallery,
    ],
  )

  const dispatch = useMemo(
    () => ({
      openGallery: handleOpenGallery,
      openFileSelect: handleOpenFileSelect,
      closeGallery: onClose,
    }),
    [handleOpenGallery, handleOpenFileSelect, onClose],
  )

  return [galleryProps, dispatch]
}
